import { cn } from "@tabipla/ui/lib/utils";

export type IllustrationName = "location-search" | "personal-notebook" | "share-link" | "exploring";

interface IllustrationProps {
  name: IllustrationName;
  alt: string;
  className?: string;
}

export function Illustration({ name, alt, className }: IllustrationProps) {
  return (
    <img
      src={`/illustrations/${name}.svg`}
      alt={alt}
      className={cn("h-auto max-w-full", className)}
      loading="lazy"
    />
  );
}
